import { render } from "./CardBody.vue?vue&type=template&id=43c7f1e5&scoped=true"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"

import "./CardBody.vue?vue&type=style&index=0&id=43c7f1e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c7f1e5"]])

export default __exports__